export default "/images/sass.svg?3e2936467e8ec06262dbd33c0f71c242";